import { NodeEdgeMapper } from '@iotv/datamodel';
import ApiGateway from '../aws/api-gateway/ApiGateway';
const debug = process.env.REACT_APP_DEBUG && false;
const userTypeRoleQuery = async function (user) {
    const path = '/getOne';
    const responseBody = (await ApiGateway.post(path, user));
    const normalizedData = new NodeEdgeMapper();
    debug && console.log('userTypeRoleQuery Res', responseBody);
    // now { err, data } TODO deal with err
    const item = responseBody.data;
    if (item?.pk && item.sk) {
        normalizedData.loadItem(item);
    }
    return normalizedData;
};
export { userTypeRoleQuery };
